import React, { useState, useLayoutEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';

const htmlDom = document.getElementsByTagName('html')[0];

export default function FormEditorWrapper() {
  const formEditorWrapperDom = useRef<TypeMePlease>(null);

  const getFormEditorHeight = () => {
    const top = formEditorWrapperDom.current.getBoundingClientRect().top;
    return htmlDom.clientHeight - top;
  };

  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    setHeight(getFormEditorHeight());

    const resizeListener = () => {
      setHeight(getFormEditorHeight());
    };
    window.addEventListener('resize', resizeListener, { capture: true });

    return () => {
      window.removeEventListener('resize', resizeListener, { capture: true });
    };
  }, [setHeight]);

  return (
    <div className="form-editor-wrapper" style={{ height: `${height}px` }} ref={formEditorWrapperDom}>
      <Outlet />
    </div>
  );
}
